import { render, staticRenderFns } from "./HealthyDetail.vue?vue&type=template&id=e3b10718&scoped=true"
import script from "./HealthyDetail.vue?vue&type=script&lang=js"
export * from "./HealthyDetail.vue?vue&type=script&lang=js"
import style0 from "./HealthyDetail.vue?vue&type=style&index=0&id=e3b10718&prod&scoped=true&lang=css"
import style1 from "./HealthyDetail.vue?vue&type=style&index=1&id=e3b10718&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3b10718",
  null
  
)

export default component.exports